// extracted by mini-css-extract-plugin
export default {"trigger":"src-layout-SalesChannelEditorLayout-css__trigger--lbdId"};